import React from 'react';

import Icon from 'ui/Icon';
import { Box } from 'ui/Layout';
import Tooltip from 'ui/Tooltip';
import { Text } from 'ui/Typography';

import { useSankeyExcelBindingContext } from '../../contexts/sankeyExcelBindingContext';

type Props = {
  isCreating: boolean;
  sankeyId: number;
};

const CellsSelectionInfo: React.FC<Props> = ({ isCreating, sankeyId }) => {
  const {
    bindingAddress,
    selectedAddress,
    isRangeSelectionValid,
    selectDiagramBindingCells,
  } = useSankeyExcelBindingContext();

  const omitValidation = !isCreating && selectedAddress === bindingAddress;

  return (
    <Box>
      {!isCreating && bindingAddress && (
        <Tooltip content="Click to select your previous data source">
          <Text
            color="gray.500"
            cursor="pointer"
            onClick={() => selectDiagramBindingCells(sankeyId)}
          >
            Previous source: <b>{bindingAddress}</b>{' '}
            <Icon color="blue.600" icon="location-crosshairs" />
          </Text>
        </Tooltip>
      )}
      {selectedAddress && (
        <Text>
          Selected source: <b>{selectedAddress}</b>{' '}
          {omitValidation ? null : isRangeSelectionValid ? (
            <Icon color="green.600" icon="check" />
          ) : (
            <Icon
              color="red.500"
              cursor="help"
              icon="warning"
              title="Please select cells in the format as described above"
            />
          )}
        </Text>
      )}
    </Box>
  );
};

export default CellsSelectionInfo;
